import { hasCapability, type User } from "../base";

export const reviewBidGuide = {
  read: (user: User) => hasCapability(user, "reviewBidGuide.read"),
  modifyDraft: (user: User) => hasCapability(user, "reviewBidGuide.modifyDraft"),
  publish: (user: User) => hasCapability(user, "reviewBidGuide.publish"),
};
